import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { CompaniesService } from '../companies.service';
import { FormGroup, NgForm } from '@angular/forms';
import { CountriesService } from 'src/app/countries/countries.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';

@Component({
  selector: 'app-companies-detail',
  templateUrl: './companies-detail.component.html',
  styleUrls: ['./companies-detail.component.scss']
})

export class CompaniesDetailComponent implements OnInit {
  @ViewChild("formDetails") public formDetails: NgForm;
  public company: any = {};
  public countries: any[];

  constructor(
    private companiesService: CompaniesService, 
    private route: ActivatedRoute, 
    private router:Router,
    private countriesService: CountriesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private coreFormService:CoreFormService
    ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params=>{
      this.loadData(params['id']);
    });
    this.loadCountries();
  }

  loadData(id: number){
    if(id != 0){
      this.companiesService.get(id).subscribe(
        data => {
          this.company = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  loadCountries(){
    this.countriesService.all({}).subscribe(
      data => {
        this.countries = data.rows;
      },   
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  cancel(){
    this.router.navigate(["/companies"]);
  }

  save(){
    if(this.coreFormService.validate(this.formDetails)){
      this.companiesService.save(this.company.id, this.company).subscribe(
        data => {
          var _msg = (this.company.id != 0 && typeof this.company.id !== "undefined") ? "modificada" : "añadida";  
          this.messageService.add({ closable: false, severity: 'success', summary: "Empresa " + _msg + " correctamente" });
          this.router.navigate(['/companies']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  delete(){
    this.confirmationService.confirm({
      message: '¿Está seguro de que desea eliminar este elemento?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.companiesService.delete(this.company.id).subscribe(
            res => {
              this.messageService.add({ closable: false, severity: 'success', summary: 'Elemento eliminado correctamente' });
              this.router.navigate(['/companies']);
            },
            error => {
              this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
            }
        );
      },
      reject: () => {
        
      }
    });
  }

}
